
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-4xl font-bold text-white mb-6">
              <strong>Excellence in Every Detail</strong>
            </h3>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              Starlight Motors offers professional mobile detailing services throughout Melbourne, 
              specializing in interior and exterior detailing, paint correction, ceramic coating, 
              and luxury starlight headliner installations.
            </p>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              <strong className="text-white">Convenience, quality, and trust</strong> — we come to your home or workplace 
              to make your car shine. Our experienced team uses premium products and advanced 
              techniques to deliver showroom-quality results with the ultimate convenience of 
              mobile service.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-car-line text-2xl text-teal-400"></i>
                </div>
                <h4 className="font-semibold text-white mb-2">
                  <a href="#services" className="hover:text-teal-400 transition-colors">
                    <strong>Mobile Service</strong>
                  </a>
                </h4>
                <p className="text-sm text-gray-400">We come to you</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-star-line text-2xl text-teal-400"></i>
                </div>
                <h4 className="font-semibold text-white mb-2">
                  <a href="#testimonials" className="hover:text-teal-400 transition-colors">
                    <strong>Premium Quality</strong>
                  </a>
                </h4>
                <p className="text-sm text-gray-400">Showroom results</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/280cd1253c69400295f9a3c7bcb0d635.jpg"
              alt="Professional mobile car detailing service in Melbourne - Starlight Motors expert technician"
              title="Mobile car detailing Melbourne - Professional service"
              className="rounded-lg shadow-xl w-full h-96 object-cover object-top"
            />
            <div className="absolute -bottom-6 -left-6 bg-teal-500 text-white p-6 rounded-lg shadow-lg">
              <div className="text-2xl font-bold">3+</div>
              <div className="text-sm">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
